// DS: MO3.4 - legacy, cleanup when shop_card feature is merged
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import cn from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DeviationDumbView from '../DeviationViews/Dumbo';
import DeviationThumbIndicators from '../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import Stats from '../Stats';
import TextRenderer from '../TextRenderer/TextRenderer';
import Details from './_partials/Details';
import ShopCardLink from './_partials/ShopCardLink';
import DeviationShopCard from './DeviationShopCard';
import s from './ShopCard.scss';
export const COVER_IMG_HEIGHT = 200;
const ShopCard = ({ deviation , width , style , showDescription =false , showStats =true , showStatusIndicator =true  })=>{
    var _deviation_stats;
    const shop_card = useFlag('shop_card');
    var _deviation_stats_favourites;
    const statsHidden = !showStats || ((_deviation_stats_favourites = (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.favourites) !== null && _deviation_stats_favourites !== void 0 ? _deviation_stats_favourites : 0) < 1;
    const dumboWidth = shop_card ? width - parseInt(s['border-width']) * 2 : width;
    if (shop_card) {
        return /*#__PURE__*/ React.createElement(DeviationShopCard, {
            width: width,
            deviation: deviation
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: _object_spread_props(_object_spread({}, style), {
            width,
            height: 'auto'
        })
    }, /*#__PURE__*/ React.createElement(ShopCardLink, {
        className: s['linked-area'],
        deviation: deviation
    }, showStatusIndicator && /*#__PURE__*/ React.createElement(DeviationThumbIndicators, {
        deviation: deviation,
        className: s['floating-indicators']
    }), /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['thumb'],
        deviation: deviation,
        width: dumboWidth,
        height: COVER_IMG_HEIGHT
    }), /*#__PURE__*/ React.createElement(Stats, {
        className: cn(s['stats'], statsHidden && s['hidden']),
        deviation: deviation,
        withViewCount: false,
        withBadges: false,
        withCommentControl: false,
        withSubscriberCount: false,
        withUserList: false,
        onlyNumbers: true
    })), /*#__PURE__*/ React.createElement(Details, {
        className: s['details'],
        deviation: deviation
    }), showDescription && deviation.textContent && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['description-text'],
        textContent: deviation.textContent
    })));
};
ShopCard.displayName = 'ShopCard';
export default ShopCard;
